import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const StarFilledIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M12.9183 2.60447C12.7603 2.23765 12.3993 2 11.9999 2C11.6005 2 11.2394 2.23765 11.0814 2.60447L8.61245 8.33763L2.39695 8.9141C1.99926 8.95099 1.66166 9.22097 1.53824 9.60081C1.41482 9.98066 1.52926 10.3975 1.82931 10.6611L6.51892 14.7809L5.14648 20.8703C5.05867 21.2599 5.21111 21.6644 5.53423 21.8992C5.85734 22.1339 6.28916 22.1539 6.63257 21.95L11.9999 18.763L17.3672 21.95C17.7106 22.1539 18.1424 22.1339 18.4655 21.8992C18.7886 21.6644 18.9411 21.2599 18.8532 20.8703L17.4808 14.7809L22.1704 10.6611C22.4705 10.3975 22.5849 9.98066 22.4615 9.60081C22.3381 9.22097 22.0005 8.95099 21.6028 8.9141L15.3873 8.33763L12.9183 2.60447Z'
          fill={color} />
  </svg>
)

export default StarFilledIcon
